<template>
	<Head>
		<meta
			property="og:type"
			content="website"
		/>
		<meta
			property="og:url"
			:content="baseUrl"
		/>
		<meta
			v-if="siteName"
			property="og:site_name"
			:content="siteName"
		/>
		<meta
			property="og:title"
			:content="title"
		/>
		<meta
			property="og:description"
			:content="description"
		/>
		<meta
			v-if="imageUrl"
			property="og:image"
			:content="imageUrl"
		/>
		<meta
			v-if="imageUrl"
			property="og:image:type"
			content="image/png"
		/>
		<meta
			v-if="imageUrl"
			property="og:image:width"
			content="1200"
		/>
		<meta
			v-if="imageUrl"
			property="og:image:height"
			content="630"
		/>
		<meta
			v-if="imageUrl"
			property="og:image:alt"
			:content="title"
		/>
		<meta
			property="og:locale"
			content="uk_UA"
		/>
		<meta
			v-if="showTwitter"
			name="twitter:card"
			content="summary_large_image"
		/>
		<meta
			v-if="showTwitter"
			name="twitter:site"
			content="@thecreditthing"
		/>
		<meta
			v-if="showTwitter"
			name="twitter:title"
			:content="title"
		/>
		<meta
			v-if="showTwitter"
			name="twitter:description"
			:content="description"
		/>
		<meta
			v-if="imageUrl && showTwitter"
			name="twitter:image"
			:content="imageUrl"
		/>
	</Head>
</template>
<script setup>
import {Head} from "@vueuse/head";
import {toRefs, ref} from "vue";

const props = defineProps({
	siteName: {
		type: String,
		default: "",
	},
	title: {
		type: String,
		default: "",
	},
	description: {
		type: String,
		default: "",
	},
	baseUrl: {
		type: String,
		default: "",
	},
	imageUrl: {
		type: String,
		default: "",
	},

});

const {siteName, title, description, baseUrl, imageUrl} = toRefs(props);
const showTwitter = ref(false);
</script>
